/**
 * ARIA SAML SSO Callback Page
 *
 * Landing point after the backend's SAML Assertion Consumer Service
 * (/auth/saml/acs — see AUTH_ENTRA_ID_SSO_PLAN.md §6) validates the
 * assertion and redirects back here with a token in the URL fragment
 * (never the query string/server logs). Storing it and navigating to `/`
 * is all this page needs to do — RequireAuth already bootstraps Redux from
 * the `me` query whenever a token exists but isAuthenticated is still
 * false, the same path a hard page refresh takes.
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setAuthToken } from '../config/apollo';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const token = params.get('token');

    if (token) {
      setAuthToken(token);
      navigate('/', { replace: true });
    } else {
      navigate('/login?error=saml', { replace: true });
    }
  }, [navigate, location.hash]);

  return (
    <div className="flex h-screen items-center justify-center text-gray-500">
      Signing you in…
    </div>
  );
}
